import { useEffect, useState } from "react";
import { useLocation } from "wouter";
import { ScorecardDialog } from "@/components/scorecard-dialog";

export default function ScorecardPage() {
  const [, navigate] = useLocation();
  const [open, setOpen] = useState(true);

  useEffect(() => {
    setOpen(true);
  }, []);

  function handleOpenChange(next: boolean) {
    setOpen(next);
    if (!next) {
      navigate("/");
    }
  }

  return <ScorecardDialog open={open} onOpenChange={handleOpenChange} />;
}
